import { testimonials, whyItems } from "@/mocks/gossipData";

export default function About() {
  return (
    <section id="about" className="mx-auto max-w-[1360px] scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14">
        <div className="order-2 lg:order-1">
          <p className="font-display text-xs font-semibold uppercase tracking-[0.25em] text-sign-600">
            About Chigua Lab
          </p>
          <h2 className="mt-2 font-heading text-2xl font-black text-ink-950 md:text-3xl">
            我们不是来带节奏的，我们是来问「凭什么」的
          </h2>
          <p className="mt-4 text-[15px] leading-8 text-ink-600">
            真瓜研究所诞生于一个朴素的想法：当一颗瓜被转得面目全非时，总该有人愿意把镜头拉回来，逐帧地、耐心地，把最接近原貌的样子还原给大家看。
          </p>
          <p className="mt-3 text-[15px] leading-8 text-ink-600">
            我们相信，吃瓜八卦的乐趣不止在于「谁和谁怎样了」，更在于看懂证据如何说话、谣言如何成型、真相如何从蛛丝马迹里浮现。于是我们写时间线、拆画面、对措辞、理数据，也把这些工法一步一步教给每一位瓜友。
          </p>
          <p className="mt-3 text-[15px] leading-8 text-ink-600">
            这条路上我们立下自己的规矩：
            <span className="font-semibold text-sign-700">只对证据负责，不对立场负责；能拆解，但绝不定性。</span>
            愿每一次围观，都多一点理性，少一点喧嚣。
          </p>

          <div className="mt-6 grid gap-3 sm:grid-cols-3">
            {whyItems.map((w) => (
              <div key={w.title} className="rounded-xl border border-ink-800/10 bg-paper-100/60 p-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-sign-500 text-paper-50">
                  <i className={`text-lg ${w.icon}`} />
                </span>
                <h3 className="mt-3 text-sm font-bold text-ink-900">{w.title}</h3>
                <p className="mt-1.5 text-xs leading-5 text-ink-500">{w.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <div className="relative">
            <div className="overflow-hidden rounded-2xl border border-ink-800/10">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20documentary%20photo%20of%20a%20small%20team%20reviewing%20printed%20evidence%20sheets%20and%20photo%20prints%20around%20a%20cream%20table%2C%20red%20and%20green%20notes%20on%20a%20corkboard%2C%20soft%20window%20light%2C%20cozy%20editorial%20atmosphere&width=860&height=620&seq=gua-about-main&orientation=landscape"
                alt="真瓜研究所团队在复盘证据板与打印资料"
                className="h-72 w-full object-cover object-top md:h-[380px]"
              />
            </div>
            <div className="absolute -bottom-5 right-4 rounded-xl border border-ink-800/10 bg-paper-50 px-5 py-3 shadow-sheet md:right-8">
              <p className="font-display text-2xl font-bold text-sign-600">2021</p>
              <p className="text-xs text-ink-500">成立于吃瓜元年</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-16">
        <div className="flex items-center justify-between">
          <div>
            <p className="font-display text-xs font-semibold uppercase tracking-[0.25em] text-sun-600">
              From The Lab
            </p>
            <h2 className="mt-1 font-heading text-xl font-black text-ink-950 md:text-2xl">
              瓜友怎么说
            </h2>
          </div>
          <div className="flex items-center gap-1 text-sun-500">
            <i className="ri-star-fill" />
            <i className="ri-star-fill" />
            <i className="ri-star-fill" />
            <i className="ri-star-fill" />
            <i className="ri-star-fill" />
            <span className="ml-2 whitespace-nowrap font-display text-lg font-bold text-ink-900">4.9</span>
          </div>
        </div>

        <div className="mt-6 grid gap-4 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure key={t.name} className="flex flex-col rounded-xl border border-ink-800/10 bg-paper-50 p-5">
              <div className="flex gap-0.5 text-sun-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm" />
                ))}
              </div>
              <blockquote className="mt-3 flex-1 text-sm leading-7 text-ink-600">“{t.text}”</blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-ink-800/10 pt-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-melon-500 text-paper-50">
                  <i className="ri-user-3-line" />
                </span>
                <div>
                  <p className="text-sm font-bold text-ink-900">{t.name}</p>
                  <p className="text-xs text-ink-400">{t.role} · {t.mark}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}